var map = {
	"./ss1.jpg": 9337,
	"./ss2.jpg": 670,
	"./ss3.jpg": 6507,
	"./ss4.jpg": 2904,
	"./ss5.jpg": 4085,
	"./ss6.jpg": 3594,
	"./ss7.jpg": 5751,
	"./ss8.jpg": 1924
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 353;